import React from 'react';
import { Checkbox, Tooltip } from '@platform/base';
import { getGlobalStorage, getTopWindow } from '@platform/api';
import classnames from 'classnames';
import ResizeObserver from 'rc-resize-observer';
import Hyperlink from '../../components/hyperlink';
import { findDOMNode } from 'react-dom';
import classNames from 'classnames';

let COLUMN_OPR_KEY = [ 'opr', 'operate'];

export default class SmallCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cardWidth: 368,
            showTipMap: {},
            hoverBackgroundShow: '',
            expandCardId:new Set(),
        };
    }
    componentWillReceiveProps (nextProps) {
        if(this.props.expandConfig?.expandAll !== nextProps.expandConfig?.expandAll) {
            this.setState({
                expandCardId:new Set(),
            })
        } 
    }
    render() {
        let { store } = this.props,
            locale = store.getLocale(),
            { showCheck, tableHead, columnCount, calcColumnCount, hiddenEmptyText } = store.getConfig();

        let checkedKeys = store.getCheckedKeys(),
            disabledKeys = store.getDisabledKeys(),
            rows = store.getVisibleRows(),
            checked = checkedKeys.size > 0 && rows.every(row => disabledKeys.has(row.key) || checkedKeys.has(row.key)),
            indeterminate = !checked && checkedKeys.size > 0 && rows.some(row => disabledKeys.has(row.key) || checkedKeys.has(row.key));

        let visibleRows = store.getVisibleRows();

        return visibleRows.length ? (
            <ResizeObserver
                onResize={offset => {
                    let { width } = offset,
                        containerWidth = width - 34, // 减去元素间间距最小2列间距24px, border 4px，为滚动条预留6px
                        count;

                    if(columnCount){
                        count = columnCount;
                        containerWidth = width - 12;
                    } else if(typeof calcColumnCount === "function") {
                        let layoutInfo =  calcColumnCount(containerWidth + 34);
                        count = layoutInfo.count;
                        containerWidth = layoutInfo.containerWidth
                    } else {
                        if (containerWidth <= 736) {
                            count = 2;
                        } else if (containerWidth <= 950) {
                            count = 2;
                        } else if (containerWidth <= 1100) {
                            containerWidth = containerWidth - 14;
                            count = 3;
                        } else if (containerWidth <= 1530) {
                            containerWidth = containerWidth - 28;
                            count = 4;
                        } else if (containerWidth <= 1850) {
                            containerWidth = containerWidth - 42;
                            count = 5;
                        } else {
                            containerWidth = containerWidth - 56;
                            count = 6;
                        }
                    }
                    this.count = count
                    // console.log('初始width', containerWidth, width);
                    this.setState({ cardWidth: containerWidth / count });
                }}
            >
                <div 
                    className='grid-table-wrapper'                 
                    onMouseLeave={() => {
                        this.setState({ currentTip: '' });
                    }} 
                >
                    {showCheck && <div className= { classnames(
                        'grid-table-header',
                    )}>
                        <div className='card-select-wrapper'>
                            <Checkbox
                                disabled={rows.length && rows.every(row => disabledKeys.has(row.key))}
                                checked={checked}
                                indeterminate={indeterminate}
                                onChange={value => {
                                    if(value){
                                        store.checkAll();
                                    } else {
                                        store.setCheckedKeys(new Set());
                                    }
                                    this.props.checkboxConfig?.onCheck?.('', { checkedKeys: store.getCheckedKeys() });
                                }}
                            /> {locale['table0036'] /** 全选 */}
                        </div>
                        {typeof tableHead === 'function' && <div className='card-customer-wrapper'>{tableHead()}</div>}
                    </div>}
                    <div className={`grid-table-body grid-card-small`}>
                        {store.getVisibleRows().map((row,index) => this.renderCard(row,visibleRows,index))}
                    </div>
                </div>
            </ResizeObserver>
        ) : (
            !hiddenEmptyText && <div className="grid-table-wrapper empty-card">
                <i className='empty-table-icon'></i>
                <span className='empty-table-text'>{locale['table0033'] /*暂无数据*/}</span>
            </div>
        );
    }

    renderCard = ( row, visibleRows, index) => {
        let { store, rowProps } = this.props,
            { cardWidth, hoverBackgroundShow, expandCardId } = this.state,
            {
                fieldConfig,
                imgSize,
                showCheck,
                renderHeader,
                renderRightTop,
                background,
                selectedBackground,
                hoverBackground,
                checkboxShow,
                checkboxPosition = 'left',
                customerCardStyle,
                clickedBorder = true,
                expandConfig = {},
                renderExtraContent,
            } = store.getConfig(),
            { title, subTitle, statusPosition, status, img, renderItems } = fieldConfig,
            {range=[], enable, expandAll} = expandConfig;
        let columns = store.getVisibleColumns(),
            checkedKeys = store.getCheckedKeys(),
            disabledKeys = store.getDisabledKeys(),
            clickedRow = store.getClickedRow(),
            titleCol,
            subTitleCol,
            statusColumns = [],
            contentColumns = [],
            buttonColKey;

        let imgPosition = imgSize ? (imgSize === 'cover' || imgSize === 'contain') ? 'top' : 'left' : false;

        if(statusPosition === 'img' && imgPosition === 'left'){
            statusPosition = 'right';
        }

        let fontSizeBaseCol = title || subTitle,
            titleFontStyle = { fontSize: Math.max(fontSizeBaseCol?.labelSize ?? 0, fontSizeBaseCol?.valueSize ?? 0, 14) };

        let rawRowProps = rowProps(row);
        let smallCardStyle = {}, 
         contentStyle = {},
         expandCardStyle = {},
         isExpand = expandCardId.has(row.key),
         fontClass = window?.nccFontSize || (window && getTopWindow() && getTopWindow().nccFontSize) || getGlobalStorage('localStorage', 'nccFontSize') || '';

        if(hoverBackgroundShow === row.key || background || selectedBackground){
            if(hoverBackgroundShow === row.key){
                background = hoverBackground;
            } else if(checkedKeys.has(row.key) && selectedBackground){
                background = selectedBackground;
            }

            if(background){
                contentStyle = {
                    position:'relative',
                    background,
                    padding: '12px 8px 0 16px',
                    margin: 0,
                };
            }
        }

        columns.forEach(column => {
            if (column.key === title) {
                titleCol = column;
            } else if (column.key === subTitle) {
                subTitleCol = column;
            } else if (COLUMN_OPR_KEY.includes(column.key) && column.render && column.itemtype === 'customer') {
                buttonColKey = column.key;
            } else if (status?.includes(column.key)) {
                statusColumns.push(column);
            } else {
                contentColumns.push(column);
            }
        });
        
        if(typeof renderItems === "function" ) {  
              contentColumns = renderItems(row)
        }

        let expandable = !expandAll && enable && range.length==2 && contentColumns.length > range[0];
        let cardLength =  visibleRows.length
        let  lastRowCount //计算哪些卡片是最后一行
        if(visibleRows.length>this.count) {
            lastRowCount = visibleRows.length % this.count ===0 ? this.count :  visibleRows.length % this.count
        } else {
            lastRowCount = cardLength
        }
        if(expandable) {  //如果配置了单个展开
            if (isExpand) {  
                expandCardStyle = { 
                    position:'absolute',
                    zIndex:90,
                };
                contentColumns = contentColumns.slice(0, range[1])
            } else  {
                contentColumns = contentColumns.slice(0, range[0]);
            }
        } else if(expandAll) { //如果全部展开了
            let cardHeight 
            if(fontClass=="large") {
                cardHeight = "506px"
            } else if (fontClass=="medium") {
                cardHeight = "470px"
            } else {
                cardHeight = "410px"
            }
            expandCardStyle = {
                height: cardHeight,
            }
        }
         
        if(typeof customerCardStyle === 'function') {
            smallCardStyle = customerCardStyle(row);
        }

        
      
        return <div 
            className={classNames(
                'small-card-wrapper-extend',
                {'card-wrapper-last': isExpand && index >= visibleRows.length-lastRowCount,
                 'small-card-expand-all':expandAll
                } 
                )} 
            rowKey={row.key} 
            style={{ width: cardWidth }}
        >
            {typeof renderHeader === 'function' && <div className='card-extend-area'>{renderHeader(row.dataIndex, row)}</div>}
            <div
                className={classnames(
                    'small-card-wrapper',
                    `card-${imgSize}`,
                    { 
                        'card-disabled' : disabledKeys.has(row.key),
                        'card-selected' : checkedKeys.has(row.key),
                        'card-checkbox-hover': checkboxShow === 'hover',
                        'card-expand': isExpand,
                        'card-clicked': !showCheck && clickedBorder && clickedRow === row.key,
                    },
                    `small-card-wrapper-${row.key}`,
                )}
                onClick={e => {
                    rawRowProps?.onClick?.(e);
                }}
                onDoubleClick={e => {
                    rawRowProps?.onDoubleClick?.(e);
                }}
                style={{  ...expandCardStyle, ...smallCardStyle, }}
            >
                {/* 图片 - 上下 */}
                {imgPosition === 'top' && img && <div className='card-img-wrapper'>
                    {typeof img === 'string' && <div className='card-img' style={{ backgroundImage: `url(${img})` }} />}
                    {typeof img === 'function' && img(row, row.dataIndex)}
                    {showCheck && this.renderCardCheckbox(row)}
                    {statusColumns.length > 0 && statusPosition === 'img' && this.renderStatusField(row, statusColumns.slice(0, 1))}
                </div>}

                {/* 内容区域 */}
                <div
                    className={classnames('card-content-wrapper',{ 'border-bottom': !!buttonColKey && !background })}
                    style={contentStyle}
                    onMouseEnter={() => this.setState({ hoverBackgroundShow: row.key })}
                    onMouseLeave={() => this.setState({ hoverBackgroundShow: '' })}
                >
                    {(() => {
                        if(!showCheck || imgPosition === 'top' || checkboxPosition === 'right') {return;}
                        return <div className={classnames(
                            'card-checkbox-wrapper',
                            `show-${checkboxPosition}`,
                            { 'show-hover': checkboxShow === 'hover' },
                            { 'card-with-img': img && imgSize },
                        )}
                        style={titleFontStyle}>
                            {this.renderCardCheckbox(row)}
                        </div>;
                    })()}

                    {/* 图片 - 左右 */}
                    {imgPosition === 'left' && img && <div className='card-img-wrapper' style={titleFontStyle}>
                        {typeof img === 'string' && <i className={`iconfont ${img} `} />}
                        {typeof img === 'function' && img(row, row.dataIndex)}
                    </div>}

                    {/* 内容, 小卡片一定有标题或者副标题 */}
                    <div className='card-column-wrapper'   >
                        {this.renderTitle(row, statusPosition, titleCol, statusColumns)}

                        {/* 副标题 */}
                        {subTitleCol && <div className='card-sub-title'>
                            {this.renderField(row, subTitleCol)}
                        </div>}

                        {/* 状态-下 */}
                        {statusPosition === 'bottom' && statusColumns.length > 0 && <div style={{ marginTop: 10 }}>{this.renderStatusField(row, statusColumns)}</div>}

                        {/* 其他列 */}
                        <div className="card-normal-column-wrapper">
                            {this.renderContent(contentColumns, row , expandable, range)}
                        </div>
                        {/* {额外区域} */}
                        {typeof renderExtraContent ==="function" && 
                        <div 
                            className='system-area'
                            // style={{marginTop: expandable && !isExpand? '0':'12px'}}
                        >
                            {renderExtraContent(row)}
                        </div> }
                    </div>
                    {showCheck && checkboxPosition === 'right' && <div className={classnames(
                        'card-checkbox-wrapper',
                        `show-${checkboxPosition}`,
                        { 'show-hover': checkboxShow === 'hover' },
                    )}
                    style={titleFontStyle}>
                        {this.renderCardCheckbox(row)}
                    </div>}
                </div>
              
                {/* 按钮 */}
                {buttonColKey && <div className='card-button-wrapper'>
                    {store.getColumnProps(buttonColKey).render('', row, row.dataIndex)}
                </div>}
            </div>
        </div>;
    }

    renderCardCheckbox = row => {
        let { store } = this.props,
             {currentTip} = this.state,
            checkedKeys = store.getCheckedKeys(),
            disabledKeys = store.getDisabledKeys(),
            disabled = disabledKeys.has(row.key);
        let {renderCheckBoxTips} = store.getConfig()
        let tipsInfo = renderCheckBoxTips?.(row, disabled)||{}
        return <Tooltip
            placement="top"
            overlay={tipsInfo.tip}
            inverse
            trigger = 'hover'
            visible = {tipsInfo.visible && currentTip===row.key}
        >
            <div
                onMouseEnter={()=>{
                    this.setState({
                        currentTip:row.key
                    })
                }}
                onMouseLeave={()=>{
                    this.setState({
                        currentTip:''
                    })
                }}
                onClick={e => e.stopPropagation()}
            >
                <Checkbox
                    className='card-checkbox'
                    disabled={disabled}
                    checked={checkedKeys.has(row.key)}
                    onChange={value => {
                        let checkedKey = row.key,
                            lastCheckedKeys = new Set([...checkedKeys]);
                        if (value) {
                            checkedKeys.add(checkedKey);
                        } else {
                            checkedKeys.delete(checkedKey);
                        }
                        store.setCheckedKeys(checkedKeys);
                    this.props.checkboxConfig?.onCheck?.(row.key, { isChecked: value, checkedKeys, lastCheckedKeys });
                    }}
                    tabIndex="-1"
                    onClick={e => e.stopPropagation()}
                />
        </div>
    </Tooltip>;
    }

    renderContent = ( contentColumns, row, expandable, range) => {
       if(expandable ) {
           return <div>
               {contentColumns.slice(0,range[0]).map(item => this.renderField(row, item))}
               {contentColumns.slice(range[0],range[1]).map(item => this.renderField(row, item))}
               {this.renderExpandIcon(row)}
        </div> 
       } else {
           return  contentColumns.map(item => this.renderField(row, item))
       }    
   }

    renderExpandIcon = row =>{
        let { expandCardId } = this.state,
        { store } = this.props,
        isExpand = expandCardId.has(row.key),
        {expandCallBack} =store.getConfig()
        return <div 
                    className={
                        classnames('expand-btn-wrapper')
                    }
                    onClick = {(e)=>{
                        e.stopPropagation();
                        expandCallBack?.(isExpand)//领域回调
                        let cardRef = findDOMNode(this)?.querySelector(`.small-card-wrapper-${row.key}`);
                        if(isExpand) {
                            expandCardId.delete(row.key);
                        } else {
                            expandCardId.add(row.key);
                        }
                        this.setState({expandCardId})
                        setTimeout(()=>{
                            cardRef.scrollIntoView({ 
                            behavior: 'smooth',
                            block: 'center',
                            inline: 'center'
                        });
                    })
        }}
        >  
           
            <hr className='expand-btn-hr'></hr>
            <span  className= {
                classnames(
                    'expand-btn-angle',
                    {'angle-expand':isExpand},
                )
            }></span>
            <hr className='expand-btn-hr'></hr>
            </div>;
    }

    renderTitle = (row, statusPosition, titleCol, statusColumns) => {
        if(statusPosition === "follow" && titleCol) {
            return  <div className='card-title card-title-status-wrapper follow-title'>
                {this.renderFollowTitle(row, titleCol, statusColumns)}
                </div>
        } else if (titleCol) {
            return <div className='card-title card-title-status-wrapper'>
                    {/* 标题 */}
                    {this.renderField(row, titleCol)}
                    {/* 状态-右 */}
                    {(statusPosition === 'right' && statusColumns.length > 0) ? this.renderStatusField(row, statusColumns.slice(0, 1)) : (
                        typeof renderRightTop === 'function' && <div className='card-extend-area-right-top'>{renderRightTop(row.dataIndex, row)}</div>
                    )}
                </div>
        }
    }

    renderFollowTitle = (row, column, statusColumns) => {
        if (!column) {return null;}

        let {
            key: colKey,
            itemtype,
        } = column;

        return <div className={` card-text-wrapper card-${itemtype}-${colKey}`}>
            <span
                className='tooltip-content-wrapper'
            >
                {this.renderTitleText(row, column, statusColumns)}
            </span>
        </div>;
    }
    renderTitleText = (row, column, statusColumns) => {
        let { store } = this.props,
            { contentStyle } = this.getStyle(column),
            searchKeyWord = store.getKeyWord(),
            {
                key: colKey,
                render,
            } = column;
            let titleWrapperRef = findDOMNode(this)?.querySelector(`.tooltip-content-${row.key}-${colKey}`);
            let isFoldRow = titleWrapperRef?.scrollHeight - titleWrapperRef?.clientHeight > 7; // 7是误差数,有的标签会撑大
        if(typeof render === 'function'){
            return render(store.getCellValue(row.key, colKey), row, row.dataIndex);
        } else {
            let content = row.values[column.key]?._display_;
            if(searchKeyWord && content.includes(searchKeyWord)){
                let contentTmp = content.split(searchKeyWord);
                content = [];
                contentTmp.forEach((e, index) => {
                    content.push(e);
                    index !== contentTmp.length - 1 && content.push(<span key={index} className="high-light">{searchKeyWord}</span>);
                });
            }
            return this.renderTooltip(
                content,
                <div 
                    className={`tooltip-content tooltip-content-${row.key}-${colKey}`} 
                    style={contentStyle} 
                    >
                    {/* 标签-右 tag 文本超出浮动用 */}
                    {
                        isFoldRow && <span className='title-tag-float' >
                            {statusColumns.length > 0 && this.renderStatusField(row, statusColumns) }
                        </span>
                    }

                    <span className={`title-content` }
                        onMouseEnter={() => {
                            this.setState({ currentTip: '' });
                            let titleWrapperRef = findDOMNode(this)?.querySelector(`.tooltip-content-${row.key}-${colKey}`);
                            let isFoldRow = titleWrapperRef?.scrollHeight - titleWrapperRef?.clientHeight > 7; // 7是误差数
                            if (isFoldRow) { 
                                this.setState({ currentTip: `${row.key}-${column.key}` });         
                            }
                        }}
                        onMouseLeave={() => {
                            this.setState({ currentTip: '' });
                        }} 
                    >
                        {content}
                    </span>
                    
                    {/* 标签-右 文本未超出跟随用 */}
                    <span className={`title-tag-follow`}>
                        {statusColumns.length > 0 && this.renderStatusField(row, statusColumns) }
                    </span>
                   
                </div>,
                row,
                column,
            );
        }
    }

    renderField = (row, column) => {
        if (!column) {return null;}

        let {
                label,
                showLabel,
                ishidefieldname,
                key: colKey,
                itemtype,
            } = column,
            { labelStyle } = this.getStyle(column);
        showLabel = showLabel === true || !ishidefieldname;
            let overlay = showLabel? `${label}:\n${row.values[column.key]?._display_}` : row.values[column.key]?._display_ ;
        return this.renderTooltip(
            overlay,
            <div 
                className={`card-col card-${itemtype}-${colKey}`}
                onMouseEnter={() => {
                    this.setState({ currentTip: '' });
                    let itemDom = findDOMNode(this)?.querySelector(`.small-card-wrapper-extend[rowkey="${row.key}"] .card-${itemtype}-${colKey}`);
                    let displayDom = findDOMNode(this)?.querySelector(`.small-card-wrapper-extend[rowkey="${row.key}"] .card-${itemtype}-${colKey} .tooltip-content`);
                    let labelDomWidth = findDOMNode(this)?.querySelector(`.small-card-wrapper-extend[rowkey="${row.key}"] .card-${itemtype}-${colKey} .card-col-label`)?.scrollWidth || 0  
                    if (itemDom?.clientWidth < displayDom?.scrollWidth + labelDomWidth+4 ) { //4是margin
                            this.setState({ currentTip: `${row.key}-${column.key}` });
                    }
                }}
                onMouseLeave={() => {
                    this.setState({ currentTip: '' });
                }} 
        >
            {showLabel && <span className='card-col-label' style={labelStyle}>
                {label}:
            </span>}
            <span
                className='card-col-display'
            >
                {this.renderColDisplay(row, column)}
            </span>
        </div>,
            row,
            column,
        );
    }

    renderColDisplay = (row, column) => {
        let { store, id } = this.props,
            { contentStyle } = this.getStyle(column),
            searchKeyWord = store.getKeyWord(),
            {
                key: colKey,
                itemtype,
                hyperlinkflag: hyperLinkFlag,
                hyperlinktype: hyperLinkType,
                hyperlinkname: hyperLinkName,
                hyperlinkurl: hyperLinkUrl,
                datatype,
                render,
            } = column;
        if(hyperLinkFlag){
            return <Hyperlink
                name={hyperLinkName}
                url={hyperLinkUrl}
                type={hyperLinkType}
                cellValue={store.getCellValue(row.key, colKey)}
                searchKeyWord={searchKeyWord}
                itemType={itemtype}
                meta={store.getMeta()}
                tableId={id}
                colKey={colKey}
                locale={store.getLocale()}
                datatype={datatype}
                className={classnames(
                    'cell-hyper',
                    'code-detail-link',
                    { 'hyper-link-out': hyperLinkType === '2' && hyperLinkUrl && itemtype !== 'refer' },
                )}
            />;
        } else if(typeof render === 'function'){
            return render(store.getCellValue(row.key, colKey), row, row.dataIndex);
        } else {
            let content = row.values[column.key]?._display_;
            if(searchKeyWord && content.includes(searchKeyWord)){
                let contentTmp = content.split(searchKeyWord);
                content = [];
                contentTmp.forEach((e, index) => {
                    content.push(e);
                    index !== contentTmp.length - 1 && content.push(<span key={index} className="high-light">{searchKeyWord}</span>);
                });
            }
            return  <div className='card-col-display-tooltip'>
            <div className='tooltip-content' style={contentStyle}>{content}</div>
        </div>
        }
    }

    renderTooltip = (overlay = '', content, row, column) => {
        let { itemtype, key: colKey } = column,
            { currentTip } = this.state;
        if (currentTip === `${row.key}-${colKey}` && itemtype !== 'attachment') {
            return <Tooltip
                placement="rightBottom"
                overlay={overlay}
                mouseEnterDelay={1}
                inverse
                visible
            >
                { content }
            </Tooltip>;
        }

        return content;
    }

    renderStatusField = (row, statusColumns) => {
        let { store } = this.props,
            { fieldConfig } = store.getConfig(),
            { statusStyle, statusPosition } = fieldConfig;

        return <span className={`card-status-wrapper status-${statusPosition}`} >
            {statusColumns.map((column, index) => {
                let { key, render, click } = column;
                if(render) { 
                    return <div
                        key={key}
                    >
                        {render?.(row.values[key], row, row.dataIndex, store)}
                    </div>;
                } else {
                    return <div
                        key={key}
                        className={`status-${key} card-status`}
                        style={{ background: statusStyle[index][row.values[key].value] }}
                        onClick={(e)=>{
                            e.stopPropagation()
                            click?.(row.values[key], row, row.dataIndex, store) 
                        }}
                    >
                        { row.values[key]?._display_}
                    </div>;
                }
   
            })
            }
        </span>;
    }

    getStyle = column => {
        return {
            labelStyle: {
                background: column.background,
                color: column.color,
                fontSize: column.fontSize,
                fontWeight: column.fontWeight,
            },
            contentStyle: {
                background: column.contentBackground,
                color: column.contentColor,
                fontSize: column.contentFontSize,
                fontWeight: column.contentFontWeight,
            },
        };
    }
}